import { useAppSelector } from "store/hooks/hooks";
import { selectLiveEvents, selectEventsStatus } from "store/slices/eventsSlice";

export const useEventBanner = () => {
    const liveEvents = useAppSelector(selectLiveEvents);
    const status = useAppSelector(selectEventsStatus);

    const isLoading = status === "loading";
    const isVisible = liveEvents.length > 0 && status === "succeeded";

    return {
        liveEvents,
        isLoading,
        isVisible
    };
};
